















module.exports =
  name: 'demo_bar'
